/// <reference types="@types/googlemaps" />
import { Component, OnInit, Input, AfterViewInit, ViewContainerRef, ViewChild } from '@angular/core';
import { fabric } from 'fabric';
import { HttpClient } from '@angular/common/http';
import { ColorPickerService, Cmyk } from 'ngx-color-picker';
import { CropperComponent } from 'angular-cropperjs';
import { CommonService } from '../../services/common.service';
import { CanvasService } from '../../services/canvas.service';
import { HttpService } from '../../services/http-service.service';


@Component({
  selector: 'core-location-street-view',
  templateUrl: './location-street-view.component.html',
  styleUrls: ['./location-street-view.component.scss']
})
export class LocationStreetViewComponent implements OnInit, AfterViewInit {

  @Input() locationInfo;
  @Input() index;
  @Input() canvasJson;
  @Input() isEditMode;
  @Input() imageData: string = null;
  @ViewChild('angularCropper', { static: true }) angularCropper: CropperComponent;

  // Streetview canvas variables

  latitude: number = 0;
  longitude: number = 0;
  imageWidth: number = 640;
  imageHeight: number = 500;
  streetViewCanvas: any;
  streetViewImageSize: string = this.imageWidth + 'x' + this.imageHeight;
  streetViewBorderColor: string = '#000000';
  streetViewStroke: string = '#FFFF00';
  streetViewFillColor: string = 'rgba(0,0,0,1)';
  streetViewStrokeWidth: number = 3;
  streetViewHeadingValue: number = 180;
  streetViewPitchValue: number = 0;
  streetViewFov: number = 90;
  isStreetViewAvailable: boolean = true;
  isStreetView: boolean = true;
  panorama: google.maps.StreetViewPanorama;
  pagman: google.maps.Map | google.maps.StreetViewPanorama;
  stateName: string = '';
  isCropMode: boolean = false;
  streetViewRequestUrl: string = '';
  cropConfig = {
    dragMode: 'move',
    background: false,
    minContainerWidth: 600,
    minContainerHeight: 400,
    movable: true,
    rotatable: true,
    scalable: true,
    zoomable: true,
    viewMode: 3,
    cropmove: this.cropMoved.bind(this),
    cropBoxResizable: false
  };
  croppedImage: any = '';
  isPagmanView: boolean = false;
  isShowAnimation = true;
  streetViewImage: string = '';
  streetViewLoading = true;

  constructor(
    public httpClient: HttpClient,
    public httpService: HttpService,
    public vcRef: ViewContainerRef,
    private cpService: ColorPickerService,
    public commonService: CommonService,
    public canvasService: CanvasService,

  ) { }

  ngOnInit(): void {
    this.commonService.states.forEach(el => {
      if (el.value === this.locationInfo.STATE) {
        this.stateName = el.name;
      }
    });
  }

  ngAfterViewInit(): void {
    this.streetViewCanvas = new fabric.Canvas('streetViewCanvas' + this.index);
    this.getCoordinates(); // First check that street view is available or not and then load an image
  }

  ngOnChanges(change): void {
    if (change.canvasJson && change.canvasJson.currentValue) {
      this.streetViewCanvas.loadFromJSON(change.canvasJson.currentValue, function () {
        if (this) {
          this.streetViewCanvas.renderAll();
        }
      }, function () {

      });
    }
    if (change.isEditMode) {
      this.isEditMode = change.isEditMode.currentValue;
      if (this.streetViewCanvas) {
        this.streetViewCanvas.loadFromJSON(this.streetViewCanvas.toJSON(), this.streetViewCanvas.renderAll.bind(this.streetViewCanvas), function (o, object) {
          if (object.type == 'image') {
            object.set('selectable', false);
          } else {
            object.set('selectable', change.isEditMode.currentValue);
          }
        });
      }
    }
  }

  // getCoordinates() - get latitude and longitude for given location
  getCoordinates(): void {
    let requestUrl = this.locationInfo.ADDRESS + ','
      + this.locationInfo.CITY + ','
      + this.locationInfo.STATE + ' '
      + this.locationInfo.ZIP + ',USA';

    this.streetViewLoading = true;
    this.httpService.getGeocode(requestUrl).subscribe((resp) => {
      if (resp.success) {
        if (resp['result'].results.length > 0) {
          this.latitude = resp['result'].results[0].geometry.location.lat;
          this.longitude = resp['result'].results[0].geometry.location.lng;
          if(this.imageData){
            this.loadSavedImage();
          }else {
            this.checkStreetViewAvailable();
          }
        }
      }
      this.streetViewLoading = false;
    }, (error) => {
      if (error) {
        this.streetViewLoading = true;
       // this.toastrService.error(error.message);
      }
    });
  }

  // checkStreetViewAvailable() - Check that street view is available or not for the given location.
  checkStreetViewAvailable(): void {
    let paramString = 'size=' + this.streetViewImageSize
      + '&heading=' + this.streetViewHeadingValue
      + '&pitch=' + this.streetViewPitchValue
      + '&fov=' + this.streetViewFov
      + '&location=' + this.latitude + ',' + this.longitude;
    this.streetViewLoading = true;
    this.httpService.checkStreetViewAvailable(paramString).subscribe((resp) => {
      if (resp.success) {
        if (resp['result'].status === 'ZERO_RESULTS') {
          this.isStreetViewAvailable = false;
        } else {
          this.streetViewLocation(false);
        }
      }
      this.streetViewLoading = false;
    }, (error) => {
      if (error) {
        this.streetViewLoading = false;
       // this.toastrService.error(error.message);
      }
    });
  }

  // streetViewLocation() - Get google street view location and load it into canvas on the basis of user entered details
  streetViewLocation(isChangeView: boolean): void {

    let paramString = 'size=' + this.streetViewImageSize
      + '&heading=' + this.streetViewHeadingValue
      + '&pitch=' + this.streetViewPitchValue
      + '&fov=' + this.streetViewFov
      + '&location=' + this.latitude + ',' + this.longitude;

    this.streetViewLoading = true;
    this.httpService.getStreetViewImage(paramString).subscribe((resp) => {
      this.streetViewImage = this.commonService._imageEncode(resp);
      // Load street view image  into canvas
      fabric.Image.fromURL(encodeURI(this.streetViewImage), (image) => {
        image.set({ left: 0, top: 0 });

        // If we are rotating view just change image else add new one
        if (isChangeView) {
          this.streetViewCanvas.item(0).set(image);
          this.streetViewCanvas.renderAll();
        } else this.streetViewCanvas.add(image);

        this.streetViewCanvas.item(0).lockMovementX = true;
        this.streetViewCanvas.item(0).lockMovementY = true;
        this.streetViewCanvas.item(0).selectable = false;

        this.streetViewLoading = false;
      }, {
        crossOrigin: 'anonymous'
      });
    }, (error) => {
      if (error) {
        this.streetViewLoading = false;
       // this.toastrService.error(error.message);
      }
    });

    // If image gets change den reinitalize cropper.
    if (isChangeView) {
      let testData = this.angularCropper.cropper;
      this.angularCropper.cropper.destroy();
      this.angularCropper.cropper = testData;
    }
  }

  onChangeColorCmyk(color: string): Cmyk {
    const hsva = this.cpService.stringToHsva(color);

    if (hsva) {
      const rgba = this.cpService.hsvaToRgba(hsva);

      return this.cpService.rgbaToCmyk(rgba);
    }

    return new Cmyk(0, 0, 0, 0);
  }

  onChangeColorHex8(color: string): string {
    const hsva = this.cpService.stringToHsva(color, true);

    if (hsva) {
      return this.cpService.outputFormat(hsva, 'rgba', null);
    }

    return '';
  }

  // changeStreetView() - Change view of the street
  changeStreetView(): void {
    if (this.isShowAnimation) this.isShowAnimation = false;

    this.isStreetView = !this.isStreetView;
    if (!this.isStreetView) {
      this.panorama = new google.maps.StreetViewPanorama(
        document.getElementById('street-view' + this.index),
        {
          position: { lat: this.latitude, lng: this.longitude },
          pov: { heading: this.streetViewHeadingValue,
            pitch: this.streetViewPitchValue }
        });
    } else {
      this.latitude = this.panorama['position'].lat();
      this.longitude = this.panorama['position'].lng();
      this.streetViewHeadingValue = this.panorama['pov'].heading;
      this.streetViewPitchValue = this.panorama['pov'].pitch;
      this.streetViewLocation(true);
    }
  }

  // changePagmanView() - Change pagman view.
  changePagmanView(): void {
    this.isPagmanView = !this.isPagmanView;
    if (this.isPagmanView) {
      setTimeout(() => {
        this.pagman = new google.maps.Map(document.getElementById('pagman-view' + this.index), {
          center: { lat: this.latitude, lng: this.longitude },
          zoom: 17
        });
      }, 500);
    } else {
      if (this.pagman['streetView']['position']) {
        this.latitude = this.pagman['streetView']['position'].lat();
        this.longitude = this.pagman['streetView']['position'].lng();
        this.streetViewHeadingValue = this.pagman['streetView']['pov'].heading;
        this.streetViewPitchValue = this.pagman['streetView']['pov'].pitch;
        if (!this.isStreetViewAvailable) {
          this.isStreetViewAvailable = true;
          this.streetViewLocation(false);
        } else {
          this.streetViewLocation(true);
        }
      }
    }
  }

  // selectShapeBorderWidth() - Select width of the border
  selectShapeBorderWidth(width: number): void {
    this.streetViewStrokeWidth = width;
    if (this.streetViewCanvas.getActiveObject()) {
      this.streetViewCanvas.getActiveObject().set('strokeWidth', this.streetViewStrokeWidth);
      this.streetViewCanvas.renderAll();
    }
  }

  // cropAnImage() - Crop an image when user select crop area
  cropAnImage(): void {
    if (this.isCropMode) {
      if (this.croppedImage) {
        // Load image of that location into canvas
        fabric.Image.fromURL(encodeURI(this.croppedImage), (image) => {
          image.set({ left: 0, top: 0 });
          image.width = this.imageWidth;
          image.height = this.imageHeight;
          this.streetViewCanvas.item(0).set(image);
          this.streetViewCanvas.renderAll();

          this.streetViewCanvas.item(0).lockMovementX = true;
          this.streetViewCanvas.item(0).lockMovementY = true;
          this.streetViewCanvas.item(0).selectable = false;
        }, {
          crossOrigin: 'anonymous'
        });
      }
    } else {
      this.croppedImage = '';
      this.angularCropper.cropper.setCropBoxData({ top: 10, left: 10, height: 350, width: 380 });
    }
    this.isCropMode = !this.isCropMode;
  }

  // cropMoved() - Create new image when user moves crop box
  cropMoved(): void {
    if (this.angularCropper.cropper.getCroppedCanvas()) {
      this.croppedImage = this.angularCropper.cropper.getCroppedCanvas().toDataURL();
    }
  }

  // viewLeft() - View left side on street view
  viewLeft(): void {
    this.streetViewHeadingValue = this.streetViewHeadingValue - 20;
    if (this.streetViewHeadingValue < 0) {
      this.streetViewHeadingValue = 360;
    }
    this.streetViewLocation(true);
  }

  // viewRight() - View right side on street view
  viewRight(): void {
    this.streetViewHeadingValue = this.streetViewHeadingValue + 20;
    if (this.streetViewHeadingValue > 360) {
      this.streetViewHeadingValue = 0;
    }
    this.streetViewLocation(true);
  }

  // viewTop() - View top side on street view
  viewTop(): void {
    if (this.streetViewPitchValue < 90) {
      this.streetViewPitchValue = this.streetViewPitchValue + 10;
      this.streetViewLocation(true);
    }
  }

  // viewDown() - View down side on street view
  viewDown(): void {
    if (this.streetViewPitchValue > -90) {
      this.streetViewPitchValue = this.streetViewPitchValue - 10;
      this.streetViewLocation(true);
    }
  }

  /** Increase Fov value */
  increaseFov(): void{
    if(this.streetViewFov < 120){
      this.streetViewFov += 5;
      this.streetViewLocation(true);
    }
  }

  /** Decrease Fov value */
  decreaseFov(): void{
    if(this.streetViewFov > 20){
      this.streetViewFov -= 5;
      this.streetViewLocation(true);
    }
  }

  /** Load Saved image */
  loadSavedImage(): void{
    // Load image of that location into canvas
    fabric.Image.fromURL(this.imageData, (image) => {
      image.set({left: 0, top: 0});

      // add new one
      this.streetViewCanvas.add(image);
      this.streetViewCanvas.item(0).lockMovementX = true;
      this.streetViewCanvas.item(0).lockMovementY = true;
      this.streetViewCanvas.item(0).selectable = false;

      this.streetViewLoading = false;
    }, {
      crossOrigin: 'anonymous'
    });
  }
}
